import * as React from 'react';

import { useProfessionalCertificates } from 'bundles/browse/components/withProfessionalCertificates';
import type { Props as LinksContainerProps } from 'bundles/directory-graphql/components/LinksContainer';
import LinksContainer from 'bundles/directory-graphql/components/LinksContainer';
import useAllDegreesData from 'bundles/directory-graphql/hooks/useAllDegreesData';
import { CourseraMetatags } from 'bundles/seo';

import _t from 'i18n!nls/directory-graphql';

type Props = LinksContainerProps & {
  metaTitle: string;
  metaDescription: string;
  disableCrawlerIndexing?: boolean;
  useFollowForDisablingIndexing?: boolean;
};

export const LinkContainerWithMetatags = ({
  titledLinks,
  metaTitle,
  metaDescription,
  disableCrawlerIndexing,
  useFollowForDisablingIndexing,
}: Props) => {
  return (
    titledLinks && (
      <div>
        <LinksContainer titledLinks={titledLinks} />

        <CourseraMetatags
          metaNameAndProperties={{
            title: metaTitle,
            description: metaDescription,
            disableCrawlerIndexing,
            useFollowForDisablingIndexing,
          }}
        />
      </div>
    )
  );
};

type DegreesProps = {
  isDirectoryHomePage: boolean;
};

export const Degrees = ({ isDirectoryHomePage }: DegreesProps) => {
  const { allDegrees } = useAllDegreesData();

  const titledLinks = allDegrees.map((degree) => ({
    title: degree.name,
    link: degree.link,
  }));
  const metaTitle = _t("Master's Degrees Directory");
  const metaDescription = _t("The Coursera Master's Degrees directory includes links to all of our master's degrees.");
  const disableCrawlerIndexing = !isDirectoryHomePage;
  const useFollowForDisablingIndexing = disableCrawlerIndexing;

  return (
    <LinkContainerWithMetatags
      titledLinks={titledLinks}
      metaTitle={metaTitle}
      metaDescription={metaDescription}
      disableCrawlerIndexing={disableCrawlerIndexing}
      useFollowForDisablingIndexing={useFollowForDisablingIndexing}
    />
  );
};

export const ProfessionalCertificates = () => {
  const { professionalCertificates } = useProfessionalCertificates();

  const titledLinks = professionalCertificates.map((cert) => ({
    title: cert.name,
    link: cert.link,
  }));
  const metaTitle = _t('Professional Certificates Directory');
  const metaDescription = _t(
    'The Coursera Professional Certificates directory includes links to all of our professional certificates.'
  );
  const disableCrawlerIndexing = true;
  const useFollowForDisablingIndexing = true;

  return (
    <LinkContainerWithMetatags
      titledLinks={titledLinks}
      metaTitle={metaTitle}
      metaDescription={metaDescription}
      disableCrawlerIndexing={disableCrawlerIndexing}
      useFollowForDisablingIndexing={useFollowForDisablingIndexing}
    />
  );
};
